<template>
    <div id="">
        <slot />
    </div>
</template>

<script>
export default {
    
}
</script>